import "./topbar.scss"
import { Mail, Call, LocationOn } from "@mui/icons-material"

function Topbar({ menuOpen, setMenuOpen }) {
    return (
        <div className={"topbar " + (menuOpen && "active")}>
            <div className="wrapper">
                <div className="left">
                    <a href="#intro" className="logo">Home</a>
                    <div className="itemContainer">
                        <Mail className="icon" />
                        <span>karlvon.taocta@yahoo.com</span>
                    </div>
                    <div className="itemContainer">
                        <Call className="icon" />
                        <span>(+63)995 981 8308/(034)461 8004</span>
                    </div>
                    <div className="itemContainer">
                        <LocationOn className="icon" />
                        <span>Blk 1 Lot 19 Lessandra Street, Camella, Brgy. Bata, Bacolod City, Negros, Occidental, Philippines</span>
                    </div>
                </div>
                <div className="right">
                    <div className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
                        <span className="line1"></span>
                        <span className="line2"></span>
                        <span className="line3"></span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Topbar;